import React, { useState, useEffect } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { useSelector, useDispatch } from 'react-redux'
import { CommonBaseURl } from '../../../Commonprovider/CommonProvider';
import './WatchListPopup.css'
import { logDOM } from '@testing-library/react';
import { UserListedValue } from '../../../CommonFunction/Functions';
export const WatchListPopup = ({ setShowWatchlistPopup, showWatchlistPopup, saveChanges, setSaveChanges }) => {
    const [BaseURL] = useState(CommonBaseURl)
    const Token = useSelector(state => state.Authenticationapi.token)
    const [searchText, setSearchText] = useState('');
    const [selected, setSelected] = useState([]);
    const [Companies, setCompanies] = useState([]);
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [searchedCompanies, setSearchedCompanies] = useState([]);
    const UserDetails = useSelector(state => state.LoginUserDetails.data)
    const UserId = JSON.parse(UserDetails).length != 0 ? UserDetails[0].UserId || JSON.parse(UserDetails)[0].UserId : ''
    const watchlistName = `${UserId}_watchlist`;
    const [watchlistData, setWatchlistData] = useState([])
    const [initialCompanies, setInitialCompanies] = useState([]);
    const [deleteWL, setDeleteWL] = useState(false);
    let [alertStatus, setAlertStatus] = useState('');
    const [previousAlerts, setPreviousAlerts] = useState([]);
    const [alertAction, setAlertAction] = useState('Enable')
    const [previousSelectedAlerts, setPreviousSelectedAlerts] = useState([]);
    const [displayADate, setDisplayADate] = useState("");
    const [selectedAlerts, setSelectedAlerts] = useState([]);
    let Listed_Only = UserListedValue()
    //.......................................................................

    let [manageDate, setManageState] = useState("")
    //........................................................................

    const [date, setDate] = useState("");

    let dividend = [2, 12, 49]
    const [alerts, setAlerts] = useState({
        dividend: false,
        stockSplit: false,
        agm: false,
        egm: false,
        bonusAnnouncement: false,
        exRights: false,
    });

    // const formatDateForInput = (date) => {
    //     if (!date) return "";
    //     const d = new Date(date);
    //     return d.toISOString().split("T")[0]; // Returns YYYY-MM-DD
    // };
    const handleChange = (event) => {
        const { name, checked } = event.target;
        setAlerts((prevAlerts) => ({
            ...prevAlerts,
            [name]: checked,
        }));
        const updatedCompanies = selectedCompanies.map((company) => ({
            ...company,
            ALERT: event.target.value, // Assuming you want to set the ADate value
        }));
        setSelectedCompanies(updatedCompanies);
    };

    const loadUserWatchlist = async () => {
        const opt = "";
        const companyCode = "";
        let Adate = "";
        const url = `${BaseURL}GetUserWatchlist?Userid=${UserId}&WListName=${watchlistName}&Opt=${opt}&Co_Code=${companyCode}&ADate=${Adate}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: "Bearer " + Token.access_token,
                },
            });
            if (!response.ok) {
                const errorText = await response.text();
                console.error("Server Response Error:", errorText);
                throw new Error(`HTTP error! Status: ${response.status} - ${errorText}`);
            }

            const data = await response.json();
            const parsedCompanies = JSON.parse(data)

            const updatedCompanies = parsedCompanies.map((company) => {
                if (company.ADate) {
                    // const formatDate = (dateString) => {
                    //     const date = new Date(dateString);
                    //     return date.toISOString().split('T')[0]; // Extracts YYYY-MM-DD
                    // };
                    // const date = new Date(company.ADate);
                    // const formattedDate = date.toISOString().split("T")[0];
                    const date = new Date(company.ADate);

                    // Adjust for local time and format as yyyy-mm-dd
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                    const year = date.getFullYear();

                    // Format it as yyyy-mm-dd or dd-mm-yyyy if preferred
                    const formattedDate = `${year}-${month}-${day}`;
                    return { ...company, displayADate: formattedDate, ADate: formattedDate };
                }
                return company;
            });

            setSelectedCompanies(updatedCompanies);
            setInitialCompanies(updatedCompanies);

            if (deleteWL) {
                setInitialCompanies(updatedCompanies);
                setDeleteWL(true);
            }
        } catch (error) {
            console.error("Error loading watchlist:", error);
        }
    };

    useEffect(() => {
        loadUserWatchlist();
    }, [displayADate]);

    const GetSearchCompanies = async (searchText) => {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        if (Token != null) {
            fetch(`${BaseURL}GetCompanySearch?text=${searchText}&ListedOnly=${Listed_Only}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'Authorization': 'Bearer ' + Token.access_token,
                }
            }).then((Response) => Response.json())
                .then((data) => {
                    let fetchedCompanies = JSON.parse(data)
                    setCompanies(fetchedCompanies);
                })
        }
    }

    const handleCompanySelection = (selected) => {
        if (selected.length === 0) return;
        setSearchedCompanies(selected[0])
        const item = selected[0];
        const date = new Date();

        // Adjust for local time and format as yyyy-mm-dd
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        // Format it as yyyy-mm-dd or dd-mm-yyyy if preferred
        const formattedDate = `${year}-${month}-${day}`;

        const newCompany = {
            LName: item.CO_NAME || item.Name,
            code: item.CO_CODE,
            ADate: formattedDate,
            displayADate: formattedDate,
            dailyUpdates: false,
        };
        const exists = selectedCompanies.some((company) => company.code === newCompany.code);

        if (!exists) {
            setSelectedCompanies([...selectedCompanies, newCompany]);
        } else {
            alert("This company is already in your watchlist.");
        }
        setSearchText("");
        setSelected([])
    };

    const showSavedWatchlistPopup = () => {
        if (Token != null) {
            fetch(`${BaseURL}GetWatchList?UserID=${UserId}&WListName=${watchlistName}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'Authorization': 'Bearer ' + Token.access_token,
                },
            }).then((response) => response.json())
                .then((json) => {
                    let data = JSON.parse(json);
                    setWatchlistData(data);
                })
        }
    }

    useEffect(() => {
        showSavedWatchlistPopup()
    }, [UserId, watchlistName])

    const deleteWatchlist = (cocode, cname) => {
        if (cocode !== undefined) {
            const opt = "DEL";
            let Adate = "";
            if (Token != null) {
                fetch(`${BaseURL}GetUserWatchlist?Userid=${UserId}&WListName=${watchlistName}&Opt=${opt}&Co_Code=${cocode}&ADate=${Adate}`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                        'Authorization': 'Bearer ' + Token.access_token,
                    },
                }).then(() => {
                    loadUserWatchlist();
                })

                    .catch((error) => {
                        console.error("Delete error:", error);
                    });
            }
        } else {
            setCompanies((prevCompanies) =>
                prevCompanies.filter((item) => item.LName !== cname)
            );
        }
    };

    const getPreviousAlerts = () => {
        const alertData = {
            userId: UserId,
            selectedAlerts: '',
            opt: 'Get',
            alertStatus: '',
        };
        if (Token != null) {
            fetch(`${BaseURL}GetUserWatchlistAlert?Userid=${alertData.userId}&Alert_List=${alertData.selectedAlerts}&Opt=${alertData.opt}&AlertActive=${alertData.alertStatus}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'Authorization': 'Bearer ' + Token.access_token,
                },
            }).then((response) => response.json())
                .then((json) => {
                    let getSelectedAlerts = JSON.parse(json);
                    setAlertStatus(getSelectedAlerts[0].AlertActive);
                    setPreviousAlerts(getSelectedAlerts[0].Alert_List);
                    setWatchlistData(getSelectedAlerts);
                    setPreviousSelectedAlerts(getSelectedAlerts);
                    setAlerts({
                        dividend: (getSelectedAlerts[0].Alert_List).includes(dividend),
                        stockSplit: (getSelectedAlerts[0].Alert_List).includes(39),
                        agm: (getSelectedAlerts[0].Alert_List).includes(45),
                        egm: (getSelectedAlerts[0].Alert_List).includes(43),
                        bonusAnnouncement: (getSelectedAlerts[0].Alert_List).includes(18),
                        exRights: (getSelectedAlerts[0].Alert_List).includes(14),
                    });

                    setAlertAction(getSelectedAlerts[0].AlertActive === 1 ? 'Enable' : 'Disable');
                })

                .catch((error) => {
                    console.error("Delete error:", error);
                });
        }
    };

    const saveWatchlist = async (opt) => {

        const alertMapping = {
            dividend: dividend,
            stockSplit: 39,
            agm: 45,
            egm: 43,
            bonusAnnouncement: 18,
            exRights: 14,
        };

        // const alerts = {
        //     dividend: previousAlerts.includes(dividend),
        //     stockSplit: previousAlerts.includes(39),
        //     agm: previousAlerts.includes(45),
        //     egm: previousAlerts.includes(43),
        //     bonusAnnouncement: previousAlerts.includes(18),
        //     exRights: previousAlerts.includes(14),
        // };

        // const selectedAlerts = Object.keys(alerts)
        //     .filter((key) => alerts[key])
        //     .map((key) => alertMapping[key]);
        const selectedAlerts = [];
        for (var key in alerts) {
            if (alerts[key]) { // If the checkbox is checked
                selectedAlerts.push(alertMapping[key]);
            }
        }
        // const alertStatus = al

        const userAlerts = {
            Userid: UserId,
            Alert_List: selectedAlerts.join(","),
            AlertActive: alertStatus,
        };

        if (selectedCompanies.length > 100) {
            alert("Please add up to 100 companies");
            return;
        }

        if (opt === "ADD") {
            try {
                for (const company of selectedCompanies) {
                    try {
                        const date = new Date(company.ADate);
                        const formattedDate = date.toISOString().split("T")[0];

                        if (company.code !== undefined) {
                            await fetch(`${BaseURL}GetUserWatchlist?Userid=${UserId}&WListName=${watchlistName}&Opt=${opt}&Co_Code=${company.code}&ADate=${formattedDate}`, {
                                method: 'GET',
                                headers: {
                                    'Content-type': 'application/json; charset=UTF-8',
                                    'Authorization': 'Bearer ' + Token.access_token,
                                },
                            });
                        }
                        else {
                            // const date = company.ADate;
                            const opt = 'upd'
                            const date = new Date(company.ADate);
                            const dd = String(date.getDate()).padStart(2, "0");
                            const mm = String(date.getMonth() + 1).padStart(2, "0");
                            const yyyy = date.getFullYear();
                            const formattedDate = `${yyyy}-${mm}-${dd}`;
                            await fetch(`${BaseURL}GetUserWatchlist?Userid=${UserId}&WListName=${watchlistName}&Opt=${opt}&Co_Code=${company.Co_Code}&ADate=${formattedDate}`, {
                                method: 'GET',
                                headers: {
                                    'Content-type': 'application/json; charset=UTF-8',
                                    'Authorization': 'Bearer ' + Token.access_token,
                                },
                            });
                        }

                    } catch (error) {
                        console.error("Error adding/updating company:", error);
                    }
                }

                // getPreviousAlerts();

                if (
                    JSON.stringify(userAlerts.Alert_List) !== JSON.stringify(previousSelectedAlerts.Alert_List) ||
                    JSON.stringify(userAlerts.AlertActive) !== JSON.stringify(previousSelectedAlerts.AlertActive)
                ) {
                    setAlertStatus(alertAction === 'Enable' ? 1 : 0)
                    const alertData = {
                        userId: UserId,
                        selectedAlerts: selectedAlerts.join(","),
                        opt: previousSelectedAlerts.length > 0 ? "UPDATE" : "ADD",
                        alertStatus: alertAction === 'Enable' ? 1 : 0
                    };


                    await fetch(`${BaseURL}GetUserWatchlistAlert?Userid=${alertData.userId}&Alert_List=${alertData.selectedAlerts}&Opt=${alertData.opt}&AlertActive=${alertData.alertStatus}`, {
                        method: 'GET',
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8',
                            'Authorization': 'Bearer ' + Token.access_token,
                        },
                    });
                    setPreviousSelectedAlerts(userAlerts);
                }

                alert("Watchlist Updated Successfully!!");
                setShowWatchlistPopup(false);

            } catch (error) {
                console.error("Error fetching company data:", error);
            }

        }
        setInitialCompanies(selectedCompanies);

        setSaveChanges(!saveChanges)


        // window.location.reload();
    };


    const closeWatchList = () => {
        debugger
        if (JSON.stringify(initialCompanies) !== JSON.stringify(selectedCompanies)) {
            if (window.confirm("Do you want to Update your Watchlist?")) {
                setShowWatchlistPopup(!showWatchlistPopup);
                saveWatchlist("ADD");

            } else {
                setCompanies(initialCompanies); // Reset companies
            }
        }
        const alertMapping = {
            dividend: dividend,
            stockSplit: 39,
            agm: 45,
            egm: 43,
            bonusAnnouncement: 18,
            exRights: 14,
        };
        // Collect selected alerts
        const newSelectedAlerts = Object.keys(alerts)
            .filter((key) => alerts[key])
            .map((key) => alertMapping[key]);

        setSelectedAlerts(newSelectedAlerts);

        const userSelectedAlerts = {
            Userid: UserId,
            Alert_List: newSelectedAlerts.join(","),
            AlertActive: alertStatus
        };

        if (!showWatchlistPopup) {
            getPreviousAlerts().then((prevAlerts) => {
                if (prevAlerts.length > 0) {
                    if (
                        userSelectedAlerts.Alert_List !== prevAlerts[0].Alert_List ||
                        userSelectedAlerts.AlertActive !== prevAlerts[0].AlertActive
                    ) {
                        if (window.confirm("Do you want to Update your Watchlist?")) {
                            // setShowWatchlistPopup(false);
                            const alertData = {
                                userId: UserId,
                                selectedAlerts: newSelectedAlerts.join(","),
                                opt: "UPDATE",
                                alertStatus
                            };

                            fetch(`${BaseURL}GetUserWatchlistAlert?Userid=${alertData.userId}&Alert_List=${alertData.selectedAlerts}&Opt=${alertData.opt}&AlertActive=${alertData.alertStatus}`, {
                                method: 'GET',
                                headers: {
                                    'Content-type': 'application/json; charset=UTF-8',
                                    'Authorization': 'Bearer ' + Token.access_token,
                                },
                            }).then(() => {
                                alert("Watchlist Updated Successfully!!");
                                setPreviousSelectedAlerts([...userSelectedAlerts]);
                                getPreviousAlerts();
                            })
                                .catch((error) => console.error("Error updating user alerts:", error));
                        }
                    }
                } else if (userSelectedAlerts.Alert_List.length > 0) {
                    if (
                        userSelectedAlerts.Alert_List !== previousSelectedAlerts.Alert_List ||
                        userSelectedAlerts.AlertActive !== previousSelectedAlerts.AlertActive
                    ) {
                        if (window.confirm("Do you want to Update your Watchlist?")) {
                            // setShowWatchlistPopup(false);
                            const alertData = {
                                userId: UserId,
                                selectedAlerts: newSelectedAlerts.join(","),
                                opt: "ADD",
                                alertStatus
                            };
                            fetch(`${BaseURL}GetUserWatchlistAlert?Userid=${alertData.userId}&Alert_List=${alertData.selectedAlerts}&Opt=${alertData.opt}&AlertActive=${alertData.alertStatus}`, {
                                method: 'GET',
                                headers: {
                                    'Content-type': 'application/json; charset=UTF-8',
                                    'Authorization': 'Bearer ' + Token.access_token,
                                },
                            }).then(() => {
                                alert("Watchlist Updated Successfully!!");
                                setPreviousSelectedAlerts([...userSelectedAlerts]);
                                getPreviousAlerts();
                            })
                                .catch((error) => console.error("Error updating user alerts:", error));
                        }
                    }
                }
            });
        }

        // setShowWatchlistPopup(!showWatchlistPopup)
    };





    useEffect(() => {
        getPreviousAlerts();
    }, []);



    const handleDateChange = (e, companyCode) => {

        let compnyCode = companyCode.Co_Code || companyCode.code
        const updatedCompanies = selectedCompanies.map((company) =>
            (company.Co_Code === compnyCode || company.code === compnyCode)
                ? {
                    ...company,
                    ADate: e.target.value,
                    //displayADate: e.target.value, 
                }
                : company


        );
        setSelectedCompanies(updatedCompanies);
    };







    return (
        <div className='modal fade show '
            style={{ display: 'block' }}
            tabIndex="-1"
            role="dialog"
        >
            <div className='common-div background-blur' ></div>
            <div className='modal-dialog modal-lg'>
                <div className='modal-content watchlistpopup'>
                    <div className='landing-box-head'>
                        <h5>Manage Watchlist</h5>
                    </div>
                    <div className='modal-body common-scroller'>

                        <div className='common-input'>
                            <Typeahead
                                id="companySearch"
                                labelKey={option => `${option.Name || option.CO_NAME}`}
                                minLength={2}
                                options={Companies}
                                style={{ color: 'red' }}
                                placeholder={`Enter Company Name`}
                                onChange={handleCompanySelection}
                                value={searchText}
                                onInputChange={(query) => {
                                    setSearchText(query);
                                    GetSearchCompanies(query);
                                }}
                                selected={selected}
                                inputValue={searchText}
                            />
                        </div>

                        <div className='checkbox-sc'>
                            <div>
                                <div> Want to Receive Alerts ?</div>
                                <div className='flex-tab email-alert'>
                                    <div>
                                        <input
                                            type="radio"
                                            value="Enable"
                                            checked={alertAction === "Enable"}
                                            onChange={() => {
                                                setAlertAction("Enable");
                                                const updatedCompanies = selectedCompanies.map((company) => ({
                                                    ...company,
                                                    alertAction: 'Enable', // Assuming you want to set the ADate value
                                                }));
                                                setSelectedCompanies(updatedCompanies);
                                            }}
                                        />
                                        <label>Yes</label>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            value="Enable"
                                            checked={alertAction === "Disable"}
                                            onChange={() => {
                                                setAlertAction("Disable");
                                                const updatedCompanies = selectedCompanies.map((company) => ({
                                                    ...company,
                                                    alertAction: 'Disable', // Assuming you want to set the ADate value
                                                }));
                                                setSelectedCompanies(updatedCompanies);
                                            }}
                                        />
                                        <label>No </label>
                                    </div>
                                    {/* {emailAlert && <span style={{ color: 'green', marginLeft: '10px' }}>Email Alert is Enabled</span>}
                                    {!emailAlert && <span style={{ color: 'red', marginLeft: '10px' }}>Email Alert is Disabled</span>} */}
                                </div>
                            </div>
                            <div className='checkbox-container'>
                                <div className='flex-tab'>
                                    <input
                                        type="checkbox"
                                        name="dividend"
                                        checked={alerts.dividend}
                                        value={alerts.dividend}
                                        onChange={handleChange}
                                    />
                                    <label>Dividend</label>
                                </div>
                                <div className='flex-tab'>
                                    <input
                                        type="checkbox"
                                        name="stockSplit"
                                        checked={alerts.stockSplit}
                                        value={alerts.stockSplit}
                                        onChange={handleChange}
                                    />
                                    <label>Stock Split</label>
                                </div>
                                <div className='flex-tab'>
                                    <input
                                        type="checkbox"
                                        name="agm"
                                        value={alerts.agm}
                                        checked={alerts.agm}
                                        onChange={handleChange}
                                    />
                                    <label>AGM</label>
                                </div>
                                <div className='flex-tab'>
                                    <input
                                        type="checkbox"
                                        name="egm"
                                        checked={alerts.egm}
                                        value={alerts.egm}
                                        onChange={handleChange}
                                    />
                                    <label>EGM</label>
                                </div>
                                <div className='flex-tab'>
                                    <input
                                        type="checkbox"
                                        name="bonusAnnouncement"
                                        checked={alerts.bonusAnnouncement}
                                        value={alerts.bonusAnnouncement}
                                        onChange={handleChange}
                                    />
                                    <label>Bonus Announcement</label>
                                </div>
                                <div className='flex-tab'>
                                    <input
                                        type="checkbox"
                                        name="exRights"
                                        checked={alerts.exRights}
                                        value={alerts.exRights}
                                        onChange={handleChange}
                                    />
                                    <label>Ex Rights</label>
                                </div>
                            </div>
                        </div>

                        <div className="landing-box-body">
                            <div className="table-responsive h-200 common-table seperatetable">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Sr.No</th>
                                            <th scope="col">Company Name</th>
                                            <th scope="col">Date of Addition</th>
                                            <th>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedCompanies.map((alertData, key) => (

                                            <tr key={key}>

                                                <td>{key + 1}</td>
                                                <td style={{textAlign:"left"}}>{alertData.LName}</td>
                                                <td>
                                                    <input
                                                        type="date"
                                                        max={new Date().toISOString().split('T')[0]}
                                                        value={alertData.ADate}
                                                        onChange={(e) => handleDateChange(e, alertData)}
                                                    />
                                                </td>
                                                <td>
                                                    <div onClick={() => { deleteWatchlist(alertData.Co_Code, alertData.LName); setSaveChanges(!saveChanges) }}>
                                                        <button className='bttn-remove'>Remove</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )

                                        )}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>


                    <div className='modal-footer'>
                        <button type='button' className="bttn-close" onClick={() => { setShowWatchlistPopup(!showWatchlistPopup); setSaveChanges(!saveChanges); closeWatchList() }}>
                            Close
                        </button>
                        <button type="button" className="bttn" onClick={() => { saveWatchlist('ADD'); }}>
                            Save changes
                        </button>
                    </div>
                </div>
            </div>



        </div>
    )
}



